"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Create = void 0;
const creator_1 = require("./base/stage/creator");
class Create {
    /**
     * Creates an instance of Create.
     *
     * @param storage The implementation of Storage.
     */
    constructor(storage) {
        this.storage = storage;
    }
    /**
     * Creates a stage for an existing tournament. The tournament won't be created.
     *
     * @param data The stage to create.
     */
    async stage(data) {
        const creator = new creator_1.StageCreator(this.storage, data);
        return creator.run();
    }
}
exports.Create = Create;
//# sourceMappingURL=create.js.map